// extracted by mini-css-extract-plugin
module.exports = {"ColoredBlock":"ColoredBlock_ColoredBlock__3Vsm0","stepNum":"ColoredBlock_stepNum__3CGfs"};